import type { FC } from "react";
import { Box, Button, Container, Paper, Typography } from "@mui/material";
import { ModalComponentState } from "interfaces/modal";
import policyText from "./policyText";

const DisplayModal: FC<ModalComponentState> = props => {
    const { closeDialog } = props;
    const phrase = policyText.termsofuse;
    return (
        <Box
            sx={{
                backgroundColor: "background.paper",
                minHeight: "100%",
                px: 1.5,
                py: 3
            }}>
            <Container maxWidth="sm">
                <Paper
                    elevation={0}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "center"
                    }}>
                    <Box display="flex" justifyContent="flex-start" alignItems="center" gap={1}>
                        <Typography color="textPrimary" variant="h6">
                            {phrase.prefix}
                        </Typography>
                        <Typography color="textPrimary" variant="h6">
                            {phrase.title}
                        </Typography>
                    </Box>
                    <Box sx={{ mt: 2, overflow: "auto", maxHeight: 500 }}>
                        {phrase.content.map((x, index) => (
                            <Box key={index} sx={{ mt: 1.5 }}>
                                <Box sx={{ mt: 1.5 }}>{x.subtitle}</Box>
                                {x.list &&
                                    x.list.map((li, k) => (
                                        <Box key={k} sx={{ pl: "20px", pb: "10px" }}>
                                            {!Array.isArray(li)
                                                ? li
                                                : li.map((em, emk) => (
                                                      <Box
                                                          key={emk}
                                                          sx={{ pl: "20px", pb: "10px" }}>
                                                          {em}
                                                      </Box>
                                                  ))}
                                        </Box>
                                    ))}
                            </Box>
                        ))}
                    </Box>
                    <Box
                        mt={4}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ width: "100%" }}>
                        <Button
                            onClick={event => closeDialog(event, "escapeKeyDown")}
                            color="primary"
                            size="large"
                            variant="contained">
                            CLOSE
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default DisplayModal;
